import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Skeleton } from '@mui/material';

import { useGetCostCentersWithGivenInterval } from '../../../../../../queries';
import ValidFromAndToSection from './ValidFromAndToSection';
import { ControlledCheckboxAutoComplete } from 'components/shared/ControlledFields';
import { onRemoveElement } from '../utils/onRemoveElement';

const HourPerPlanUnitSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, getValues, setValue, watch } = useFormContext();
  const { data: customerCostCenter, isFetching } =
    useGetCostCentersWithGivenInterval(
      getValues('valid_from'),
      getValues('valid_to')
    );

  return (
    <>
      <ValidFromAndToSection />
      <Box sx={{ width: '100%' }}>
        {isFetching ? (
          <Skeleton />
        ) : (
          <ControlledCheckboxAutoComplete
            fullWidth
            name={'br_id_list'}
            label={t('customerCostCenter')}
            variant="outlined"
            options={customerCostCenter ?? []}
            control={control}
            idProperty="value"
            labelProperty="label"
            allowItemRemoval
            onRemoveElement={(id) =>
              onRemoveElement(setValue, watch, 'br_id_list', id)
            }
          />
        )}
      </Box>
    </>
  );
};

export default HourPerPlanUnitSection;
